export const version_env = {
  number: '1.4.0',
  release_date: '2025-11-07',
  date: '07 de noviembre de 2025'
}
